export default __webpack_public_path__ + "static/media/bharat-billpay-w.913e4f99.webp";